import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { PlantCode } from "src/model/class/general classes/plant-code";
import { PlantCodeABB } from "src/model/class/general classes/plant-code-abb";
import { PlantCodeGeneric } from "src/model/class/general classes/plant-code-generic";

//#region "ONLY-PLANT-CODE" IMPLEMENTATION
export const fullPlantCodesData = createFeatureSelector<PlantCode>(
  AppSettings.KEY_PLANT_CODES
);

/**
 * Sub-selector for "ABB"-specific plant-codes; if there are none, it returns a empty list.
 */
export const ABBPlantCodes = createSelector(
  fullPlantCodesData,
  (fullPlantCodeData: PlantCode) => {
    return fullPlantCodeData?.plantCodeABB || new Array<PlantCodeABB>();
  }
);

/**
 * Sub-selector for "Generic"-type plant-codes; if there are none, it returns a empty list.
 */
export const genericPlantCodes = createSelector(
  fullPlantCodesData,
  (fullPlantCodeData: PlantCode) => {
    return fullPlantCodeData?.plantCodeGeneric || new Array<PlantCodeGeneric>();
  }
);
//#endregion
